module.exports = __webpack_public_path__ + "static/media/social activist.9545d7d1.jpeg";